import type { CartEntry } from "@larder/shared";
import { useEffect, useState } from "react";
import { watchCart } from "./cart";

/** The household's shopping list, live. */
export function useCart(locationId: string | null): {
  entries: CartEntry[];
  error: string | null;
} {
  const [entries, setEntries] = useState<CartEntry[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!locationId) {
      setEntries([]);
      return;
    }
    setError(null);
    return watchCart(locationId, setEntries, (e) => setError(e.message));
  }, [locationId]);

  return { entries, error };
}
